import React from "react";
import { useState, useContext } from "react";
import { data, useLocation } from "react-router-dom";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { PAYPAL_CHECKOUT_URL, ALERT_TIMEOUT } from "../Config";
import PurchaseComplete from "./PurchaseComplete";
import { LoggedInContext } from "../../App";

function PurchaseContent() {
  //location
  const location = useLocation();
  //user data sent from page
  const userData = location.state; // Access the data

  //
  //get ai detector values
  // eslint-disable-next-line no-unused-vars
  const {setCheckIfLoggedin } = useContext(LoggedInContext);

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //purchase state
  const [purchaseDetails, setPurchaseDetails] = useState({
    purchase_completed: false,
    purchase_status_success: false,
    purchase_message: "",
    transaction_id: "",
    reference_id: "",
    item_name: "",
    item_price: "",
  });

  //cancel paypal payment
  const onCancel = async () => {
    //show alert
    //set alert state to show error
    setAlert({
      type: "danger",
      message: "Payment cancelled. Please start again.",
      visible: true,
    });
    //hide alert after 5 seconds
    setTimeout(() => {
      setAlert({ ...alert, visible: false });
    }, ALERT_TIMEOUT);
  };

  //on paypal payment error
  //such as invalid order id
  const onError = async (error) => {
    //show alert
    //set alert state to show error
    setAlert({
      type: "danger",
      message: error,
      visible: true,
    });
    //hide alert after 5 seconds
    setTimeout(() => {
      setAlert({ ...alert, visible: false });
    }, ALERT_TIMEOUT);
  };

  //create order
  const createOrder = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //order id
    var order_id = null;

    try {
      //fetch the status from the API
      await fetch(PAYPAL_CHECKOUT_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // if needed
        },
        body: JSON.stringify({
          order_type: userData.item.item_name.toUpperCase(),
          request_type: "CREATE_ORDER",
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          //check
          if (data.success === true) {
            //set order id
            order_id = data.order_id;
          } else {
            //show alert
            //set alert state to show error
            setAlert({
              type: "danger",
              message: data.message,
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          }

          console.log("Response:", data);
        })
        .catch((error) => {
          console.error("Error:", error);
          //show alert
          //set alert state to show error
          setAlert({
            type: "danger",
            message: "Sorry, something went wrong. Please try again later.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        });

      //return
      if (order_id != null) {
        //return
        return order_id;
      }

      //error message
      const errorMessage = data.error_message_if_any;
      throw new Error("Could not initiate PayPal Checkout. " + errorMessage);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  //on approve payment
  const onApprove = async (data, actions) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    try {
      //fetch the status from the API
      await fetch(PAYPAL_CHECKOUT_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // if needed
        },
        body: JSON.stringify({
          request_type: "CAPTURE_ORDER",
          order_id: data.orderID,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          //set
          setPurchaseDetails({
            ...purchaseDetails,
            purchase_completed: true,
            purchase_message: data.message,
            purchase_status_success: data.success,
            item_name: data.item_name,
            item_price: data.price,
            transaction_id: data.transaction_id,
            reference_id: data.reference_id,
          });

          //check
          if (data.success === true) {
            //set
            //callback
            setCheckIfLoggedin(true);
            //show alert
            //set alert state to show success
            setAlert({
              type: "success",
              message: data.message,
              visible: true,
            });

            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT * 2);
          } else {
            //check issue
            if (data.issue === "INSTRUMENT_DECLINED") {
              //restrat payment
              return actions.restart();
            }

            //show alert
            //set alert state to show error
            setAlert({
              type: "danger",
              message: data.message,
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          }

          console.log("Response:", data);
        })
        .catch((error) => {
          console.error("Error:", error);
          //show alert
          //set alert state to show error
          setAlert({
            type: "danger",
            message: "Sorry, something went wrong. Please try again later.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  return (
    <div className="p-3">
      <div className="container">
        <div style={{ marginTop: "6rem" }}>
          {/* Alert for failure */}
          <div
            className={`alert alert-${alert.type} ${
              alert.visible ? "" : "d-none"
            } fade show`}
            role="alert"
            style={{ marginTop: "5rem" }}
          >
            {alert.message}
          </div>

          {/*Purchase screen */}
          {purchaseDetails.purchase_completed === false ? (
            <div>
              {/* title */}
              <h1 className="display-4 text-center mt-2">Checkout</h1>

              {/* Item details */}
              {userData === null ? (
                <div className="lead mt-5 text-center">
                  Sorry, something went wrong. Please try again later.
                </div>
              ) : (
                <div>
                  <div className="row justify-content-center">
                    {/* Left panel */}
                    <div className="col-sm-6 mt-5">
                      <p className="lead">
                        Purchase {userData.item.item_name} version
                      </p>
                      <h1>US${userData.item.item_price}</h1>

                      <div className="row border-bottom">
                        <div className="col-sm-8 mt-4">
                          <h6>{userData.item.item_name}</h6>
                          <p className="text-muted">
                            {userData.item.item_description}
                          </p>
                        </div>

                        <div className="col-sm-4 mt-4 text-end">
                          <h5> US${userData.item.item_price}</h5>
                        </div>
                      </div>

                      <div className="row border-bottom">
                        <div className="col-sm-8 mt-4">
                          <h5>Subtotal</h5>
                        </div>

                        <div className="col-sm-4 mt-4 text-end">
                          <h5> US${userData.item.item_price}</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Paypal Buttons */}
                  <div className="row justify-content-center">
                    {/* Left panel */}
                    <div className="col-sm-6 mt-5">
                      <PayPalButtons
                        style={{ layout: "vertical" }} // Customize button style
                        createOrder={createOrder}
                        onApprove={onApprove}
                        onError={onError}
                        onCancel={onCancel}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <PurchaseComplete data={purchaseDetails} />
          )}
        </div>
      </div>
    </div>
  );
}

export default PurchaseContent;
